import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCouponContract = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32.000000 32.000000",
	preserveAspectRatio: "xMidYMid meet",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
		fill: "currentColor",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M12 308 c-17 -17 -17 -279 0 -296 17 -17 279 -17 296 0 17 17 17 279 0 296 -17 17 -279 17 -296 0z m224 -76 c19 -13 25 -42 9 -48 -19 -8 -19 -33 -1 -48 10 -8 12 -18 5 -34 -8 -20 -15 -22 -81 -22 -40 0 -78 4 -84 8 -19 13 -25 42 -9 48 19 8 19 33 1 48 -10 8 -12 18 -5 34 8 20 15 22 81 22 40 0 78 -4 84 -8z" })
	})
});
export default SvgCouponContract;
